import React from 'react';
import './HowItWorksSteps.css';

const steps = [
  {
    title: 'Post',
    desc: <>Share one daily photo of your pup based on <strong>fun themed challenges</strong>.<br />Compete for <strong>NYC top dog status</strong> and climb the leaderboard.</>
  },
  {
    title: 'Discover',
    desc: <>Find the best dog parks, groomers, vets, and shops near you:<br /><strong>all reviewed</strong> by <strong>real dog owners</strong>.</>
  },
  {
    title: 'Connect',
    desc: <>Every walk becomes an adventure.<br /><strong>Meet local pups, join events,</strong> and <strong>explore NYC's</strong> dog scene together.</>
  }
];

export default function HowItWorksSteps() {
  const images = [
    require('./assets/images/ios-leaderboard.png'),
    require('./assets/images/ios-map-review-light.png'),
    require('./assets/images/ios-new-profile-light.png'),
  ];
  return (
    <div className="how-steps-vertical">
      {steps.map((step, idx) => (
        <div className="how-step-vertical" key={idx}>
          <div className="how-step-content">
            <div className="how-step-title">{step.title}</div>
            <div className="how-step-desc">{step.desc}</div>
          </div>
          <img src={images[idx]} alt={`Yuppy NYC dog app ${step.title} feature - ${step.title === 'Post' ? 'daily photo challenges for NYC dogs' : step.title === 'Vote' ? 'bone voting system for dog photos' : 'connecting NYC dog owners'}`} className="how-step-img" />
        </div>
      ))}
    </div>
  );
} 